<template>
  <div>
<!--    <canvas ref="canvas" id='pfJS'>-->
<!--    </canvas>-->
  </div>
</template>

<script>
// import init from './particlefield.js'
// export default {
//   mounted () {
//     init(this.$refs.canvas)
//   },
//   name: "Banner",
// }
</script>

<style scoped>
canvas {
  width: 100%;
  height: 201px;
}
</style>